/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreCommonExcelExportExcelRequest,
  FacilityFlowCoreCommonExcelImportResultDto,
  FacilityFlowCoreModulesCustomersDtosCustomerDto,
  FacilityFlowCoreModulesCustomersWorkflowsCreateCustomerRequest,
  FacilityFlowCoreModulesCustomersWorkflowsCreateCustomerResponse,
  FacilityFlowCoreModulesCustomersWorkflowsSearchCustomersResponse,
  FacilityFlowCoreModulesCustomersWorkflowsUpdateCustomerRequest,
  GetApiV1CustomersParams,
  PostApiV1CustomersImportExcelBody,
  PostApiV1CustomersImportExcelParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getCustomers = () => {
/**
 * @summary Search customers with optional filters
 */
const getApiV1Customers = (
    params?: GetApiV1CustomersParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersWorkflowsSearchCustomersResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersWorkflowsSearchCustomersResponse>(
      {url: `/api/v1/customers`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new customer
 */
const postApiV1Customers = (
    facilityFlowCoreModulesCustomersWorkflowsCreateCustomerRequest: FacilityFlowCoreModulesCustomersWorkflowsCreateCustomerRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersWorkflowsCreateCustomerResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersWorkflowsCreateCustomerResponse>(
      {url: `/api/v1/customers`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesCustomersWorkflowsCreateCustomerRequest
    },
      options);
    }
  /**
 * @summary Get customer by ID
 */
const getApiV1CustomersId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosCustomerDto>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosCustomerDto>(
      {url: `/api/v1/customers/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing customer
 */
const putApiV1CustomersId = (
    id: string,
    facilityFlowCoreModulesCustomersWorkflowsUpdateCustomerRequest: FacilityFlowCoreModulesCustomersWorkflowsUpdateCustomerRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesCustomersDtosCustomerDto>>,) => {
      return customInstance<FacilityFlowCoreModulesCustomersDtosCustomerDto>(
      {url: `/api/v1/customers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesCustomersWorkflowsUpdateCustomerRequest
    },
      options);
    }
  /**
 * @summary Delete a customer
 */
const deleteApiV1CustomersId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/customers/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Download all customers as an Excel workbook. The file can be edited and fed back
into the import endpoint — rows keep their technical ID, new rows leave it blank.
 */
const postApiV1CustomersExportExcel = (
    facilityFlowCoreCommonExcelExportExcelRequest: FacilityFlowCoreCommonExcelExportExcelRequest,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/customers/export/excel`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreCommonExcelExportExcelRequest,
        responseType: 'blob'
    },
      options);
    }
  /**
 * @summary Import an edited customer workbook. With `dryRun=true` (the default) the
response is a preview and nothing is written; call again with `dryRun=false`
to apply it.
 */
const postApiV1CustomersImportExcel = (
    postApiV1CustomersImportExcelBody: PostApiV1CustomersImportExcelBody,
    params?: PostApiV1CustomersImportExcelParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreCommonExcelImportResultDto>>,) => {const formData = new FormData();
if(postApiV1CustomersImportExcelBody.file !== undefined) {
 formData.append(`file`, postApiV1CustomersImportExcelBody.file)
 }
if(postApiV1CustomersImportExcelBody.excludeRows !== undefined) {
 postApiV1CustomersImportExcelBody.excludeRows.forEach(value => formData.append(`excludeRows`, value));
 }

      return customInstance<FacilityFlowCoreCommonExcelImportResultDto>(
      {url: `/api/v1/customers/import/excel`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params
    },
      options);
    }
  return {getApiV1Customers,postApiV1Customers,getApiV1CustomersId,putApiV1CustomersId,deleteApiV1CustomersId,postApiV1CustomersExportExcel,postApiV1CustomersImportExcel}};
export type GetApiV1CustomersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCustomers>['getApiV1Customers']>>>
export type PostApiV1CustomersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCustomers>['postApiV1Customers']>>>
export type GetApiV1CustomersIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCustomers>['getApiV1CustomersId']>>>
export type PutApiV1CustomersIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCustomers>['putApiV1CustomersId']>>>
export type DeleteApiV1CustomersIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCustomers>['deleteApiV1CustomersId']>>>
export type PostApiV1CustomersExportExcelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCustomers>['postApiV1CustomersExportExcel']>>>
export type PostApiV1CustomersImportExcelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCustomers>['postApiV1CustomersImportExcel']>>>
